import { render } from "./account.vue?vue&type=template&id=0b0f1291&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import "./account.vue?vue&type=style&index=0&id=0b0f1291&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0f1291"]])

export default __exports__